/**
 * This file was automatically generated by `IconCodeGenerator`.
 * DO NOT MODIFY IT BY HAND. Instead, follow the instructions at `src/shared/joykit/packages/core/icons/README.md`.
 */

import * as React from 'react';

import createSvgIcon from '../createSvgIcon';

import { SvgIconConfig } from '../types';

const config: SvgIconConfig = {
  title: 'Arrow Down',
  definitions: {
    '16': {
      viewBox: '0 0 16 16',
      path: (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1.61104 8.61104C1.82583 8.39625 2.17407 8.39625 2.38886 8.61104L7.44995 13.6721V0.999951C7.44995 0.696195 7.69619 0.449951 7.99995 0.449951C8.30371 0.449951 8.54995 0.696195 8.54995 0.999951V13.6721L13.611 8.61104C13.8258 8.39625 14.1741 8.39625 14.3889 8.61104C14.6036 8.82583 14.6036 9.17407 14.3889 9.38886L8.38886 15.3889C8.17407 15.6036 7.82583 15.6036 7.61104 15.3889L1.61104 9.38886C1.39625 9.17407 1.39625 8.82583 1.61104 8.61104Z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
};

const icon = createSvgIcon(config);
export default icon;
